import React, { useEffect, useState } from "react";
import { getLink, objectToFormData, toast } from "../../../utils/helpers";
import { useLocation } from "react-router-dom";
import { useHistory } from "../../../utils/router";
import Form from "./Form";
import { postRequest } from "../../../utils/request";
import { apiUrl } from "../../../utils/apiUrl";
import HistorialPaciente from "./Components/HistorialPaciente";
import dayjs from "dayjs";

const Create = () => {
    const history = useHistory();
    const location = useLocation();

    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [visita, setVisita] = useState({
                paciente: null,
                fecha: dayjs().format("YYYY-MM-DDTHH:mm"),
                tipo: 'Médica',
                motivo: null,
                signos: {temperatura: '', presion: '', frecuencia: ''},
                derivacion: 0,
                insumos: [],
                observaciones: '',
            });
    const [esValido, setEsValido] = useState(false);

    const cancelar = () => {
        const from = location.state?.from || getLink("/salud/visitas");

        history.push(from);
    }

    const crearVisita = async (exit = true) => {
        if (!esValido) return toast('Favor llenar todos los campos requeridos', 'error');

        setSaving(true);

        setErrors({});

        const data = objectToFormData(visita);

        const response = await postRequest(apiUrl("salud/visitas"), data);
        
        if (response.success) {
            setVisita({
                paciente: null,
                fecha: dayjs().format("YYYY-MM-DDTHH:mm"),
                tipo: visita.tipo,
                motivo: null,
                signos: visita.tipo === 'Médica' ? {temperatura: '', presion: '', frecuencia: ''} : {estado: ''},
                derivacion: 0,
                insumos: [],
            });

            toast('Visita Creada', 'success');

            if (exit) history.push(getLink("/salud/visitas"));
        }
        if (response.code === 422) {
            setErrors(response.data.message);
        }

        setSaving(false);
    };

    return <>
        <div className="row">
            <div className="col-md-6 order-2 order-md-1">
                <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
                    <h1>Registrar Visita</h1>

                    <Form visita={visita} setVisita={setVisita} setEsValido={setEsValido} errors={errors} saving={saving} />
                </div>
            </div>

            <div className="col-md-6 order-1 order-md-2">
                {visita.paciente?.pacienteable_id 
                    ? <HistorialPaciente
                        saving={saving}
                        paciente={visita.paciente}
                        errors={errors}
                        onChange={(paciente) => setVisita({
                            ...visita,
                            paciente,
                        })}
                    ></HistorialPaciente>
                    : <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
                        <div className="text-center"> Seleccione un paciente para ver el historial.</div>
                    </div>
                }
            </div>
        </div>

        <div className="row pt-4">
            <button
                type="button"
                className="btn btn-plain ml-auto mr-2"
                onClick={cancelar}
            >
                Descartar
            </button>

            <button
                type="button"
                className="btn btn-outline-primary mx-2"
                onClick={() => crearVisita(false)}
            >
                Guardar y crear nueva
            </button>

            <button
                type="button"
                className="btn btn-primary ml-2 mr-3"
                onClick={() => crearVisita(true)}
            >
                Guardar
            </button>
        </div>
    </>;
};

export default Create;